import {IPageResponse} from "../../common/interfaces/IPageResponse";
import {IPageRequest} from "../../common/interfaces/IPageRequest";
import {ModalProps, ModalType} from "../../common/common-models";
import { UploadedFile } from "components/FileUpload/FileUploadFormGroup";

export interface IPetrolStationsState {
    petrolStations: IPageResponse<IPetrolStation> | null;
    stationFeatures: IPageResponse<IStationFeature> | null;
    pageRequest: IPageRequest<IPetrolStationSortFields>;
    isEditModalVisible: boolean;
    isDeleteModalVisible: boolean;
    modalType: ModalType;
    petrolStation?: IPetrolStation
}

export interface IPetrolStation {
    id: number;
    nameEt: string;
    nameEn?: string;
    nameRu?: string;
    descriptionEt?: string;
    descriptionEn?: string;
    descriptionRu?: string;
    phoneNumber?: string;
    street?: string;
    city?: string;
    postalCode?: string;
    locationEt?: string;
    locationEn?: string;
    locationRu?: string;
    latitude?: number;
    longitude?: number;
    externalId?: string;
    dateModified?: string;
    enabledFeatures: Array<number> | [];
    enabledProducts: Array<number> | [];
    originalFileName?: string;
}

export interface IPetrolStationTableProps {
    petrolStations: IPageResponse<IPetrolStation>;
    openPetrolStationModal: (modalType: ModalType, petrolStation?: IPetrolStation) => void;
    openDeletePetrolStationModal: (petrolStation: IPetrolStation) => void;
    onPageChange: (targetPage: number) => void;
}

export interface IStationFeature {
    id: number;
    nameEt: string;
    nameEn: string;
    nameRu: string;
    code: string;
    dateCreated: string;
}

export enum IPetrolStationSortFields {
    ID = "ID",
    NAME_ET = "NAME_ET",
    NAME_EN = "NAME_EN",
    NAME_RU = "NAME_RU",
    DATE_MODIFIED = "DATE_MODIFIED"
}
export interface IPetrolStationsSearchBarProps {
    openPetrolStationModal: (modalType: ModalType, petrolStation?: IPetrolStation) => void;
}

export interface IPetrolStationConfirmModalProps extends ModalProps {
    stationFeatures: Array<IStationFeature>;
    editingPetrolStation?: IPetrolStation;
    loadPetrolStations: () => void;
}

export interface IPetrolStationForm {
    nameEt: string;
    locationEt: string;
    descriptionEt: string;
    phoneNumber?: string;
    street?: string;
    city?: string;
    postalCode?: string;
    externalId: string;
    latitude: string;
    longitude: string;
    enabledFeatures: Array<number>;
    image? : UploadedFile
}